/* Built In Imports */
import React from 'react';

/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Services */

/**
 * Renders the SgX Section Title component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 */

const SgXSectionTitle = ({ sectionContent, region, lang }) => {
  return (
    <Box display="block">
      <Text
        as="p"
        color="#FFBD31"
        fontSize={{ base: '12px', md: '16px' }}
        letterSpacing="1.5px"
        textTransform="uppercase"
        fontFamily="FedraSansStd-book"
      >
        {sectionContent?.titleSubtext}
      </Text>
      <Text
        as="h2"
        fontSize={{ base: '24px', md: '50px' }}
        fontFamily="FedraSansStd-A-medium"
        color="#ffffff"
      >
        {sectionContent?.titleText}
      </Text>
    </Box>
  );
};

export default SgXSectionTitle;
